/**
 * Geocoding contracts — city-name search used to capture an establishment's
 * location (latitude, longitude, timezone, altitude), which nothing else in the
 * product can populate today.
 *
 * The coordinates a search returns are the **municipality centroid**, not the
 * farm gate. That is fine for an ~11 km forecast grid, but nothing needing
 * property-level precision (paddock geometry, area, boundary maths) may read
 * them — `grassOptzPaddocks.boundaryGeoJson` remains the only surveyed source.
 */
export var GeocodingProviderId;
(function (GeocodingProviderId) {
    GeocodingProviderId["OPEN_METEO"] = "open_meteo";
})(GeocodingProviderId || (GeocodingProviderId = {}));
//# sourceMappingURL=Geocoding.js.map